export const CREATE_COMET_CHAT_USER_BEGIN = "CREATE_COMET_CHAT_USER_BEGIN";
export const CREATE_COMET_CHAT_USER_SUCCESS = "CREATE_COMET_CHAT_USER_SUCCESS";
export const CREATE_COMET_CHAT_USER_FAILURE = "CREATE_COMET_CHAT_USER_FAILURE";
export const RESET_CREATE_COMET_CHAT_USER = "RESET_CREATE_COMET_CHAT_USER";

export const UPDATE_COMET_CHAT_USER_BEGIN = "UPDATE_COMET_CHAT_USER_BEGIN";
export const UPDATE_COMET_CHAT_USER_SUCCESS = "UPDATE_COMET_CHAT_USER_SUCCESS";
export const UPDATE_COMET_CHAT_USER_FAILURE = "UPDATE_COMET_CHAT_USER_FAILURE";
export const RESET_UPDATE_COMET_CHAT_USER = "RESET_UPDATE_COMET_CHAT_USER";
